document.addEventListener('DOMContentLoaded', function () {
  var btn = document.getElementById('back-to-top');
  if (!btn) return;

  var ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        var doc = document.documentElement;
        var scrollTop = window.scrollY || window.pageYOffset;
        var docHeight = Math.max(doc.scrollHeight || 0, doc.offsetHeight || 0);

        // If page shorter than viewport, never show
        if (docHeight <= window.innerHeight) {
          btn.classList.remove('show');
          btn.setAttribute('aria-hidden', 'true');
          ticking = false;
          return;
        }

        if (scrollTop > (docHeight / 2)) {
          btn.classList.add('show');
          btn.setAttribute('aria-hidden', 'false');
        } else {
          btn.classList.remove('show');
          btn.setAttribute('aria-hidden', 'true');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  // Initialize
  onScroll();

  window.addEventListener('scroll', onScroll, { passive: true });

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    // Respect reduced motion
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!prefersReduced && 'scrollBehavior' in document.documentElement.style) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.scrollTo(0, 0);
    }
  });

  // keyboard support
  btn.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      btn.click();
    }
  });
});
